/**
 * @generated SignedSource<<bd1dc4b7454e6e4dc9e1febd2fd2247b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StartAndAutoRecordingControls_refetchableAutoRecordReason$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"StreamAutoRecordAutomationConfig_useAutoRecordReason_stream">;
  readonly " $fragmentType": "StartAndAutoRecordingControls_refetchableAutoRecordReason";
};
export type StartAndAutoRecordingControls_refetchableAutoRecordReason$key = {
  readonly " $data"?: StartAndAutoRecordingControls_refetchableAutoRecordReason$data;
  readonly " $fragmentSpreads": FragmentRefs<"StartAndAutoRecordingControls_refetchableAutoRecordReason">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./AutoRecordReasonStream.graphql'),
      "identifierField": "id"
    }
  },
  "name": "StartAndAutoRecordingControls_refetchableAutoRecordReason",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StreamAutoRecordAutomationConfig_useAutoRecordReason_stream"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "NoteStream",
  "abstractKey": null
};

(node as any).hash = "3b74077c53a25d52dbd2d50a6ad9f13f";

export default node;
